import React, {Component} from 'react'
import {ListGroup} from "reactstrap";
import Post from "../../../Component/PostList/Post/Post";
import firebase from "../../../Config/firebase";
import {isAuth} from "../../../Utils/firebaseUtils";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {MDBBtn, MDBCardBody, MDBCol, MDBContainer, MDBRow} from "mdbreact";
import classes from "../../../Layout/ViewPost/ViewPost.module.css";

const db = firebase.firestore()

class MyCollection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myCollectionData: [],
            member: {}
        }
    }

    componentDidMount() {
        console.log('in')
        if (isAuth(this.props.auth)) {
            this.getMyCollectionID(this.props.auth.uid)
            this.getMemberByID(this.props.auth.uid)
        }
    }

    getMyCollectionID = async (uid) => {
        db.collection('Member')
            .doc(uid)
            .collection('MyCollection')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allCollection = []
                    docs.forEach(function (doc) {
                        const collection = {
                            id: doc.id,
                            ...doc.data()
                        }
                        allCollection.push(collection)
                    })
                    this.getMyCollectionPost(allCollection)
                }

            })
    }
    getMyCollectionPost = async (allCollection) => {
        console.log(allCollection)
        allCollection.map(e => {
            db.collection('Post')
                .doc(e.postID)
                .get()
                .then(doc => {
                    console.log(doc.data())
                    if (doc.exists) {
                        let allMyCollection = this.state.myCollectionData
                        const MyCollection = {
                            id: doc.id,
                            isPinned: e.isPinned,
                            collectionID: e.id,
                            ...doc.data()
                        }
                        allMyCollection.push(MyCollection)
                        this.setState({
                            myCollectionData: allMyCollection
                        }, () => this.setState({
                            isLoaded: true
                        }))
                    }

                })
        })
        console.log(this.state.myCollectionData)
    }
    changePin = async (cid, isPinned, uid, index) => {

        if (isPinned) {
            db.collection('Member')
                .doc(uid)
                .collection('MyCollection')
                .doc(cid)
                .update({
                    isPinned: false
                })
                .then(doc => {

                })
            db.collection('Member')
                .doc(uid)
                .update({
                    countPinned: firebase.firestore.FieldValue.increment(-1)
                })
                .then(doc => {
                    this.getMemberByID(uid)
                })
            let allMyCollection = this.state.myCollectionData
            allMyCollection[index].isPinned = false
            this.setState({
                myCollectionData: allMyCollection
            })

        } else {
            console.log(uid, cid)
            if ((this.state.member.hasOwnProperty("countPinned") && this.state.member.countPinned < 5) || !this.state.member.hasOwnProperty("countPinned")) {
                db.collection('Member')
                    .doc(uid)
                    .collection('MyCollection')
                    .doc(cid)
                    .update({
                        isPinned: true
                    })
                    .then(doc => {

                    })
                db.collection('Member')
                    .doc(uid)
                    .update({
                        countPinned: firebase.firestore.FieldValue.increment(1)
                    })
                    .then(doc => {
                        this.getMemberByID(uid)
                    })
                let allMyCollection = this.state.myCollectionData
                allMyCollection[index].isPinned = true
                this.setState({
                    myCollectionData: allMyCollection
                })

            } else if (this.state.member.countPinned >= 5) {
                alert('you can`t pin more then 5')
            }

        }
    }
    getMemberByID = async (uid) => {
        db.collection('Member')
            .doc(uid)
            .get()
            .then(doc => {
                this.setState({
                    member: doc.data()
                })
            })
            .catch(err => console.log(err))
    }

    render() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBCol xl={12} lg={12} md={12} sm={12} xs={12}>
                        <h1>
                            我的收藏
                        </h1>
                        <ListGroup flush>
                            {
                                this.state.isLoaded ?
                                    this.state.myCollectionData.map((post, index) => {
                                        return (
                                            <div>
                                                <Post
                                                    key={index}
                                                    data={post}
                                                />
                                                <MDBBtn color='primary'
                                                        onClick={() => {
                                                            this.changePin(post.collectionID, post.isPinned, this.props.auth.uid, index)
                                                        }}
                                                >
                                                    {post.isPinned ? 'UnPin' : 'Pin'}
                                                </MDBBtn>
                                            </div>

                                        )
                                    })
                                    : ''
                            }
                        </ListGroup>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        );
    }
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)
export default enhance(withRouter(MyCollection))